import ListaHistorico from './ListaHistorico'
import enhancer from './ListaHistorico.enhancer'

export default enhancer(ListaHistorico)


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Historico/components/ListaHistorico/index.js